const initialState = {
  kpis: {},
  compareData: {},
  regions: [],
  districts: [],
  stores: [],
  groups: [],
  SVs: [],
  allTrends: {},
  byPeriod: {
    selectedKPIValues: [],
    comparedKPIValues: []
  }, // byPeriod
  callTracker: {},
  // graphModel
  graphModel:false,
  graphObj:{}
};

export default initialState;